import React from "react"
import PropTypes from "prop-types"
import { withRadium, DetectCompact } from "higher-order-components"
import { VideoWithTimedFrames } from "components"
import { BrowserHeightSection } from "AtomicContainers"

/**
 * Renders a Hero Video With Timed Frames Component.
 * @returns {ReactElement} React Component
 */
const HeroVideoWithTimedFrames = ({
  videoSrc, frames = [], loopVideo, fallbackImage, muted, compact = "false", scrollToSlug
}) => {
  return (
    <div data-test="hero-video-with-timed-frames">
      {compact && frames && frames.length > 0 &&
        <div style={{
          width: "100%",
          height: "100vw"
        }}>
          <VideoWithTimedFrames
            styles={{ height: "100%" }}
            loopVideo={loopVideo}
            muted={muted}
            useInView={false}
            scrollToSlug={scrollToSlug}
            videoSrc={videoSrc}
            poster={fallbackImage}
            frames={frames} />
        </div>
      }

      {!compact && frames && frames.length > 0 &&
        <BrowserHeightSection>
          <VideoWithTimedFrames
            styles={{ height: "100%" }}
            loopVideo={loopVideo}
            muted={muted}
            useInView={false}
            scrollToSlug={scrollToSlug}
            videoSrc={videoSrc}
            poster={fallbackImage}
            frames={frames} />
        </BrowserHeightSection>
      }
      {/* if there is no frame return nothing */}
      {!frames || frames.length === 0 &&
        <div />
      }
    </div>
  )
}

HeroVideoWithTimedFrames.propTypes = {
  videoSrc: PropTypes.string.isRequired,
  loopVideo: PropTypes.bool,
  muted: PropTypes.bool,
  compact: PropTypes.bool,
  scrollToSlug: PropTypes.string,
  fallbackImage: PropTypes.string,
  frames: PropTypes.arrayOf(PropTypes.shape({
    time: PropTypes.number,
    components: PropTypes.node
  }))
}

export default withRadium(DetectCompact())(HeroVideoWithTimedFrames)



// WEBPACK FOOTER //
// ./src/containers/hero-video-with-timed-frames/index.jsx